import { EntityModel } from '@/interfaces'
import {
  ALL_DESTINATIONS_BLOCKS_QUERY,
  CREATE_DESTINATIONS_BLOCK_MUTATION,
  DELETE_DESTINATIONS_BLOCK_MUTATION,
  FORCE_DELETE_DESTINATIONS_BLOCK_MUTATION,
  SINGLE_DESTINATIONS_BLOCK_QUERY,
  UPDATE_DESTINATIONS_BLOCK_MUTATION,
} from './graphql'
import travelDestinationEntity from '@/entities/travelDestination/entity'

const cmsDestinationsBlockModel: EntityModel = {
  name: 'destinationsBlock',
  namePlural: 'destinationsBlocks',
  uniqueName: 'cmsDestinationsBlock',
  uniqueNamePlural: 'cmsDestinationsBlocks',
  path: 'cms/blocks/destinations_block',
  baseUrl: '/cms/blocks/destinations_blocks',
  translationPrefix: 'entities:cmsDestinationsBlock.',
  getDisplayName: (values: any) => {
    return 'Destinations Block'
  },
  gql: {
    getAll: ALL_DESTINATIONS_BLOCKS_QUERY,
    getSingle: SINGLE_DESTINATIONS_BLOCK_QUERY,
    create: CREATE_DESTINATIONS_BLOCK_MUTATION,
    update: UPDATE_DESTINATIONS_BLOCK_MUTATION,
    delete: DELETE_DESTINATIONS_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_DESTINATIONS_BLOCK_MUTATION,
  },
  attributes: {
    destinations: {
      name: 'destinations',
      label: 'entities:cmsDestinationsBlock.attributes.destinations.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelDestinationEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsDestinationsBlockModel
